import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { WidgetAISidebar, GiadaAvatar } from '../ai';
import { TrendingUp, AlertCircle, Calendar, Lightbulb } from 'lucide-react';
interface RedemptionsChartProps {
  data: {
    date: string;
    redemptions: number;
  }[];
}
const RedemptionsChart: React.FC<RedemptionsChartProps> = ({
  data
}) => {
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const suggestions = [{
    id: '1',
    category: 'Crescita',
    title: 'Picco di riscatti il weekend',
    description: "I riscatti aumentano del 35% nei weekend. Considera di lanciare premi speciali il venerdì per massimizzare l'engagement.",
    icon: TrendingUp
  }, {
    id: '2',
    category: 'Strategia',
    title: 'Calo mid-week rilevato',
    description: "Mercoledì e giovedì hanno -20% riscatti. Prova notifiche push o email reminder per stimolare l'attività.",
    icon: AlertCircle
  }, {
    id: '3',
    category: 'Ottimizzazione',
    title: 'Trend stagionale positivo',
    description: 'Gennaio mostra +12% vs dicembre. Approfitta del momentum con campagne mirate nei prossimi 30 giorni.',
    icon: Calendar
  }];
  return <>
      <div className="rounded-lg border border-gray-200 bg-white p-6" data-id="element-456">
        <div className="flex items-center justify-between mb-4" data-id="element-457">
          <h3 className="text-lg font-semibold" data-id="element-458">Riscatti nel Tempo</h3>
          <div style={{
          background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 50%, rgba(116, 10, 214, 1) 100%)',
          padding: '2px',
          borderRadius: '100px'
        }} data-id="element-459">
            <button onClick={() => setIsAISidebarOpen(true)} className="text-black transition-colors flex items-center gap-1.5 bg-white px-3 py-1.5 hover:bg-gray-50" style={{
            borderRadius: '100px'
          }} title="AI Insights" data-id="element-460">
              <span className="text-sm" data-id="element-461">Suggerimenti AI</span>
            </button>
          </div>
        </div>
        <div className="h-64" data-id="element-462">
          <ResponsiveContainer width="100%" height="100%" data-id="element-463">
            <LineChart data={data} margin={{
            top: 5,
            right: 10,
            left: 0,
            bottom: 5
          }} data-id="element-464">
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-465" />
              <XAxis dataKey="date" stroke="#6B7280" fontSize={12} data-id="element-466" />
              <YAxis stroke="#6B7280" fontSize={12} data-id="element-467" />
              <Tooltip contentStyle={{
              backgroundColor: '#FFFFFF',
              border: '1px solid #E5E7EB',
              borderRadius: '0.5rem'
            }} formatter={(value: number) => [value, 'Riscatti']} labelFormatter={label => `Data: ${label}`} data-id="element-468" />
              <Line type="monotone" dataKey="redemptions" stroke="#108d3e" strokeWidth={2} dot={{
              fill: '#108d3e',
              r: 4
            }} data-id="element-469" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <WidgetAISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} widgetInfo={{
      title: 'Riscatti nel Tempo',
      description: 'Analisi AI dei trend temporali dei riscatti per identificare pattern, picchi e opportunità di ottimizzazione.'
    }} suggestions={suggestions} data-id="element-470" />
    </>;
};
export default RedemptionsChart;